// Remembers the ordered ids from the last list/search so the detail page can
// offer prev/next navigation (the legacy "previous account | next account").

type Kind = 'highschools' | 'districts';

export function setBrowseList(kind: Kind, ids: string[]): void {
  try {
    sessionStorage.setItem(`browse:${kind}`, JSON.stringify(ids));
  } catch {
    /* storage unavailable */
  }
}

export function getSiblings(kind: Kind, id: string): { prev?: string; next?: string } {
  try {
    const ids: string[] = JSON.parse(sessionStorage.getItem(`browse:${kind}`) || '[]');
    const i = ids.indexOf(id);
    if (i < 0) return {};
    return {
      prev: i > 0 ? ids[i - 1] : undefined,
      next: i < ids.length - 1 ? ids[i + 1] : undefined,
    };
  } catch {
    return {};
  }
}
